import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const SERIES = [
  { key: 'personalDataQuantity', color: 'var(--vo-warning)', labelKey: 'personalDataPlural' },
  { key: 'sensitivePersonalDataQuantity', color: 'var(--vo-success)', labelKey: 'sensitivePersonalDataPlural' },
];

const LegendRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--vo-slate);
`;

const Swatch = styled.div`
  width: 12px;
  height: 12px;
  background: ${p => p.$color};
  border-radius: 3px;
  flex-shrink: 0;
`;

const AreaBlock = styled.div`
  margin-bottom: 16px;
  &:last-child { margin-bottom: 0; }
`;

const AreaName = styled.p`
  font-size: 12px;
  font-weight: 600;
  color: var(--vo-ink-2);
  margin: 0 0 8px;
`;

const BarsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const BarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SeriesLabel = styled.span`
  font-size: 11px;
  color: var(--vo-slate);
  width: 120px;
  flex-shrink: 0;
`;

const Track = styled.div`
  flex: 1;
  height: 16px;
  background: var(--vo-mist);
  border-radius: 4px;
  overflow: hidden;
`;

const Bar = styled.div`
  height: 100%;
  width: ${p => p.$pct}%;
  background: ${p => p.$color};
  border-radius: 4px;
`;

const BarCount = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${p => p.$color};
  min-width: 24px;
  text-align: right;
`;

const Empty = styled.div`
  font-size: 13px;
  color: var(--vo-slate);
`;

export const GraphicAreaData = ({ indicatorDataGraphicByArea }) => {
  const { t } = useTranslation('mapping');
  const data = indicatorDataGraphicByArea ?? [];
  const maxVal = Math.max(1, ...data.flatMap(row => SERIES.map(s => row[s.key] ?? 0)));

  return (
    <div>
      <LegendRow>
        {SERIES.map(s => (
          <LegendItem key={s.key}>
            <Swatch $color={s.color} />
            {t(`ropa.executiveSummary.${s.labelKey}`)}
          </LegendItem>
        ))}
      </LegendRow>
      {data.map((row, i) => (
        <AreaBlock key={i}>
          <AreaName>{row.name}</AreaName>
          <BarsWrap>
            {SERIES.map(s => {
              const val = row[s.key] ?? 0;
              const pct = (val / maxVal) * 100;
              return (
                <BarRow key={s.key}>
                  <SeriesLabel>{t(`ropa.executiveSummary.${s.labelKey}`)}</SeriesLabel>
                  <Track><Bar $color={s.color} $pct={pct} /></Track>
                  <BarCount $color={s.color}>{val}</BarCount>
                </BarRow>
              );
            })}
          </BarsWrap>
        </AreaBlock>
      ))}
      {data.length === 0 && <Empty>{t('ropa.executiveSummary.noData')}</Empty>}
    </div>
  );
};
